import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
// import { debounce } from "lodash";

const Portal = ({
    children,
    className = "root-portal",
    rootId,
    el = "div",
    dataFieldKey,
    dataPortalKey,
    position,
    onSizeReady, // callback for updating the size of portal (to handle the calculations in SmartPortal for example),
    sizeTrigger,
    portalWidth,
    isVisible = true,
}) => {
    const [container] = useState(() => {
        // This will be executed only on the initial render
        // https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
        const element = document.createElement(el);
        if (dataFieldKey) {
            element.setAttribute("data-field-key", dataFieldKey);
        }
        if (dataPortalKey) {
            element.setAttribute("data-portal-key", dataPortalKey);
        }
        return element;
    });

    function tryToUpdateSize() {
        const rect = container && container.getBoundingClientRect();
        if (rect) {
            const { width, height } = rect;
            if (width && height && onSizeReady && typeof onSizeReady === 'function') {
                onSizeReady(rect);
            }
        }
    }

    useEffect(() => {
        if (position) {
            const { left, top, right, bottom } = position;
            if (left) {
                container.style.left = `${left}px`;
            }
            if (top) {
                container.style.top = `${top}px`;
            }
            if (right) {
                container.style.right = `${right}px`;
            }
            if (bottom) {
                container.style.bottom = `${bottom}px`;
            }
        }
    }, [position]);

    useEffect(() => {
        if (onSizeReady && typeof onSizeReady === "function") {
            setTimeout(() => {
                tryToUpdateSize();
            }, 0);
        }
    }, [container, sizeTrigger]);

    useEffect(() => {
        if (!isVisible) {
            container.style.visibility = "hidden";
            container.style.opacity = "0";
        } else {
            container.style.visibility = "visible";
            container.style.opacity = "1";
        }
    }, [isVisible]);

    useEffect(() => {
        if (portalWidth) {
            container.style.width = `${portalWidth}px`;
        }
    }, [portalWidth]);

    useEffect(() => {
        const classNames = className.trim().split(" ");
        classNames.forEach(name => {
            container.classList.add(name);
        });
        if (rootId && document.getElementById(rootId)) {
            document.getElementById(rootId).appendChild(container);
        } else {
            document.body.appendChild(container);
        }

        let resizeObserver = null;
        if (onSizeReady && typeof onSizeReady === 'function') {
            // const onResizeContainer = debounce(() => {
                // tryToUpdateSize();
            // }, 0);
            // resizeObserver = new ResizeObserver(onResizeContainer);
            resizeObserver = new ResizeObserver(tryToUpdateSize);
            resizeObserver.observe(container);
        }

        return () => {
            if (resizeObserver) {
                resizeObserver.unobserve(container);
            }
            if (rootId && document.getElementById(rootId)) {
                document.getElementById(rootId).removeChild(container);
            } else {
                document.body.removeChild(container);
            }
        };
    }, []);

    return ReactDOM.createPortal(children, container);
};

export default Portal;
